import {
  libraries, library,
  createLibrary, removeLibrary,
  addTemplateToLibrary, removeTemplateFromLibrary
} from "@/services/libraries.js";

export default {
  state: {
    loading: null,
    libraries: null,
    library: {
      name: null,
      id: null,
      templates: [],
    }
  },
  mutations: {
    setLibraries(state, libraries) {
      state.libraries = libraries;
    },
    setLibrary(state, library) {
      state.library.name = library.name;
      state.library.id = library.id;
      state.library.templates = library.templates;
      state.loading = null;
    },
    loadingLibrary(state, library_id_or_name) {
      state.loading = library_id_or_name;
    }
  },
  actions: {
    async loadLibraries({state, dispatch}) {
      if (state.libraries === null) return dispatch('reloadLibraries');
    },
    async reloadLibraries({commit}) {
      let libs = await libraries();
      commit('setLibraries', libs);
    },
    async loadLibrary({dispatch, commit, state}, library_id) {
      commit('loadingLibrary', library_id);
      if (/[^0-9]/.test(library_id)) {
        await dispatch('loadLibraries');
        library_id = state.libraries.find(({name}) => name === library_id).id;
      }
      let result = await library(library_id);
      commit('setLibrary', result);
    },
    async addTemplate({state, commit}, template_id) {
      let {id} = state.library;
      let result = await addTemplateToLibrary(id, template_id);
      commit('setLibrary', result);
    },
    async removeTemplate({state, commit}, template_id) {
      let {id} = state.library;
      let result = await removeTemplateFromLibrary(id, template_id);
      commit('setLibrary', result);
    },
    setLibrary({dispatch}, library){
      // library may or may not be a complete representation of the library.
      // Just load it.
      return dispatch('loadLibrary', library.id);
    },
    async createLibrary({commit, dispatch}, name) {
      let library = await createLibrary({name});
      dispatch('reloadLibraries');
      return library;
    },
    async deleteLibrary({dispatch}, id) {
      await removeLibrary(id);
      return dispatch('reloadLibraries');
    },
  },
  getters: {
    libraryTemplates: state => state.library.templates,
    libraryName: state => state.library.name,
    libraries: state => state.libraries,
  }
};



// WEBPACK FOOTER //
// ./src/store/libraries.js